<script>
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    eventGroupState, isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { createEventDispatcher } from 'svelte';
import { toast } from '@zerodevx/svelte-toast';
import autoFormat from '@cclib/functions/eventGroups/autoFormat.js';
import * as m from "@app/paraglide/messages.js";

const dispatch = createEventDispatcher();
let isLocked = $derived(isSelectedEventGroupLocked());

function autoFormatEvents() {
    try {
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        let maxLines = eventGroupState[projectState.selected] ? eventGroupState[projectState.selected].maxLines : 2;
        let maxChars = eventGroupState[projectState.selected] ? eventGroupState[projectState.selected].maxChars : 32;
        let minDuration = eventGroupState[projectState.selected] ? eventGroupState[projectState.selected].minDuration : 1;

        let tempSelect = [...eventGroupState[projectState.selected].selected];
    
        try {
            eventGroupState[projectState.selected] = autoFormat(eventGroupState[projectState.selected], maxLines, maxChars, minDuration, true, eventGroupState[projectState.selected].selected);
        } catch (err){
            console.log(err.message);
        }

        eventGroupState[projectState.selected].selected = [];
        setTimeout(() => {
            eventGroupState[projectState.selected].selected = tempSelect;
        }, 50);
        
        toast.push(m.context_menu_auto_format_done(), {
            classes: ["toast-success"]
        });

        insertHistoryAction({
            name: "auto format", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally{
        dispatch("done");
    }
}
</script>

<a id="btnAutoFormat"
   role="menuitem"
    aria-label={m.context_menu_auto_format_label()}
   aria-disabled={isLocked}
   class="dropdown-item" class:disabled={isLocked} href="#!/"
   onclick={autoFormatEvents}>
    {m.context_menu_auto_format()}
</a>
